import { Backdrop } from '@mui/material';
import OktaAuth, { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { BrowserRouter as Router } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import './App.css';
import { oktaConfig, oktaExternalConfig } from './common/okta/Okta.Config';
import Routes from './Routes';
import { getLoaderState } from './store/APISlice';
import { useSelector } from 'react-redux';


const oktaAuthInt = new OktaAuth(oktaConfig);

const oktaAuthExt = new OktaAuth(oktaExternalConfig);

const App = () => {

  const isInternalUser = true;

  const oktaAuth = isInternalUser ? oktaAuthInt : oktaAuthExt;

  const restoreOriginalUri = (_oktaAuth: any, originalUri: any) => {
    window.location.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  const isLoading: any = useSelector(getLoaderState);

  return (
    <>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <Router>
            <Routes />
          </Router>
      </Security>
      {isLoading &&
        <Backdrop open={true} sx={{ color: '#fff', zIndex: 1301 }}>
          <PulseLoader color="white" />
        </Backdrop>
      }
    </>
  );
};

export default App;